import axios from "axios";

// const API_URL = "http://localhost:8000/index.php/api";
// const API_URL = "http://locahost:8001";
// const API_URL = "http://172.104.193.133/admin/index.php/api/";
const API_URL = "http://www.latamup.com/admin/index.php/api/";
const token =
  "eyJpdiI6ImhGZnZQRCs3emphdlJVN3c3VTh0cVE9PSIsInZhbHVlIjoibHA4dXQwRGNLZ044QW5EeCtUbUpUdz09IiwibWFjIjoiMjczNTEzMjMzNjY0YWM2MDQ1YjNjZGM2ODUwOWIzMjMzN2JhYzBiZDIxMDdmNzJjYzIzY2RiOWVhYTM3M2M1YiJ9";

export default {
  addRow({ commit }, params) {
    console.log("llego aqui");
    console.log(commit);
    console.log(params);
    console.log("llego aqui");
    return axios({
      baseURL: API_URL,
      url: params.url,
      data: params.inputs,
      method: params.type,
      headers: { token: token },
    });
  },
  getDataAdmin({ commit }, params) {
    console.log("llego aqui");
    console.log(commit);
    console.log(params);
    console.log("llego aqui");
    return axios({
      baseURL: API_URL,
      url: params.url,
      params: { ...params },
      method: params.type,
      headers: { token: token },
    });
  },
};
